import { inject, Injectable } from '@angular/core';
import { DialogService, NotificationType } from '@schir-int-client/tech';
import { isNil } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class EipErrorhandler {
	private dialogService = inject(DialogService);

	handle(info: ErrorInformation, messageType: string) {
		const msg =
			'<h2>eIP-Client meldet Fehler in ' +
			messageType +
			'</h2>\n' +
			'<p>' +
			this.sanitize(info.Message) +
			'</p>\n' +
			'<h3>Stacktrace</h3>\n' +
			'<p>' +
			this.sanitize(info.Stacktrace)?.replace(/\n/g, '<br/>') +
			'</p>';
		this.dialogService.openAcknowledgeDialog(msg, NotificationType.ERROR);
	}

	assertNoError(messageObj: any, messageType: string) {
		const errorInfo = messageObj[messageType].ErrorInformation;
		if (!isNil(errorInfo)) {
			this.handle(errorInfo, messageType);
			throw new Error('eIP communication failed');
		}
	}

	private sanitize(text: string) {
		return text?.replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
}

// Elemente definiert in 01-base5.xsd
export interface ErrorInformation {
	Message: string;
	Id?: string;
	VariableValue?: string;
	Stacktrace?: string;
}
